import MainHeader from '@ifca-root/react-component/src/components/Header/MainHeader'
import { ContentWrapper } from '@ifca-root/react-component/src/components/Layout/ContentWrapper'
import ReportViewer, {
  accountxReportUrl,
} from 'containers/DigitalReportModule/ReportViewer'
import { formatDashDate } from 'helpers/StringNumberFunction/FormatDate'
import React from 'react'
import { useHistory, useLocation } from 'react-router'

export const StockUsageByDepartmentReport = () => {
  const history = useHistory()
  const user = JSON.parse(localStorage.getItem('loggedInUser'))
  const accountID = user.accountID
  let location = useLocation()
  const editData = location?.state as any

  const parameters = [
    { name: 'accountid', value: accountID },
    { name: 'companyid', value: editData?.CompanyID ?? undefined },
    {
      name: 'startdate',
      value: editData?.StartDate
        ? formatDashDate(new Date(editData?.StartDate).toISOString())
        : null,
    },
    {
      name: 'enddate',
      value: editData?.EndDate
        ? formatDashDate(new Date(editData?.EndDate).toISOString())
        : null,
    },
    {
      name: 'trxnstartdate',
      value: editData?.TrxnStartDate
        ? formatDashDate(new Date(editData?.TrxnStartDate).toISOString())
        : null,
    },
    {
      name: 'trxnenddate',
      value: editData?.TrxnEndDate
        ? formatDashDate(new Date(editData?.TrxnEndDate).toISOString())
        : null,
    },
    { name: 'docno', value: editData?.DocNo ?? undefined },
    { name: 'refno', value: editData?.DocRef ?? undefined },
    { name: 'stockcategoryid', value: editData?.StockCategoryID },
    { name: 'stockitemid', value: editData?.StockItemID },
    { name: 'warehouseid', value: editData?.WarehouseID },
    { name: 'doctype', value: editData?.DocType },
    { name: 'transactiontypeid', value: editData?.TransactionTypeID },
    { name: 'mastercoaid', value: editData?.MasterCOAID },
    { name: 'costcentreid', value: editData?.CostCentreID },
    { name: 'amount', value: editData?.Amount ?? undefined },
  ]

  const generatedurl = (reportName, parameters) => {
    let reporturl = reportName

    parameters?.map((x, index) => {
      const symbol = index === 0 ? '?' : '&'
      if (x?.value !== undefined)
        reporturl = reporturl + symbol + x?.name + '=' + x?.value
    })
    return reporturl
  }

  return (
    <>
      <MainHeader
        onClick={() => history.push(`/digital-reports/inventory-control`)}
        mainBtn="close"
        smTitle="Inventory Control"
        title={user?.accountName}
        routeSegments={[
          { name: 'Main Menu' },
          { name: 'Digital Reporting' },
          { name: 'Stock Usage By Department', current: true },
        ]}
        rightRouteSegments={[{ name: 'Report', current: true }]}
      />
      <ContentWrapper style={{ maxHeight: '100%' }}>
        {ReportViewer({
          url: generatedurl('StockUsageByDepartment', parameters),
          host: accountxReportUrl,
          // host: contractReportUrl,
          excludedExportFormat: [],
        })}
      </ContentWrapper>
    </>
  )
}
